import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { VideoBlob } from '@nativewaves/nw-cloud-sdk/content'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useVideoObjectBlobDeleteMutation } from 'hooks/mutations/content'
import { videoObjectBlobsOverviewRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Objects/Object/Blobs'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<VideoBlob>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { videoobjectId } = videoObjectBlobsOverviewRoute.useParams()
  const { mutate: deleteVideoObjectBlob } = useVideoObjectBlobDeleteMutation()

  const handleDeletion = useCallback(() => {
    onClose()

    setTimeout(() => {
      deleteVideoObjectBlob(
        { videoId: videoobjectId, blobId: row.original.id },
        {
          onSuccess: () => {
            enqueueSnackbar(t('domain:Workspace.Video.blobDeleted', { count: 1 }), { variant: 'success' })
          },
          onError: () => {
            enqueueSnackbar(t('somethingWentWrong'), { variant: 'error' })
          },
        },
      )
    }, 300)
  }, [deleteVideoObjectBlob, enqueueSnackbar, onClose, row.original.id, t, videoobjectId])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeletion} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
